import React from 'react'
import { Row, Col, Divider } from 'antd';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faUser from '@fortawesome/fontawesome-free-solid/faUser'
import {
  faFacebook, faGithub, faMedium, faLinkedin,
} from '@fortawesome/fontawesome-free-brands'

const PageFooter = ({

}) => {
    return (
      <div className="container white-text">
        <h3> <FontAwesomeIcon icon={faUser} /> CONTACT </h3>
        <Divider />
        <Row type="flex" gutter={16} justify="center" align="top" className="mt-5">
          <a href="https://fb.com/Pozterzz" target="_blank"><FontAwesomeIcon icon={faFacebook} size="4x" /></a>
          <a href="https://github.com/Pozterz" target="_blank"><FontAwesomeIcon icon={faGithub} size="4x" /></a>
          <a href="https://medium.com/@pozterz.jojo" target="_blank"><FontAwesomeIcon icon={faMedium} size="4x" /></a>
          <a href="https://linkedin.com/in/pozterz/" target="_blank"><FontAwesomeIcon icon={faLinkedin} size="4x" /></a>
        </Row>
      </div>
    );
}

export default PageFooter


// WEBPACK FOOTER //
// ./src/components/PageFooter.js